export enum STATUS {
  all = 'all',
  active = 'active',
  incomplete = 'incomplete',
  analyzing = 'analyzing',
  waiting = 'waiting',
  expired = 'expired',
  deactivated = 'deactivated'
}
